const sliderSwiper = new Swiper(".slider .swiper-container", {
    direction: 'horizontal',
    loop: false,
    pagination: {
      el: ".slider .swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".slider .swiper-button-next",
      prevEl: ".slider .swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: false,
  
    breakpoints: {
      749: {
        spaceBetween: 50,
      },
      }
});